import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/pruefprogramme/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="CheckProgram"
      returnRoute="/auswahlfelder/checkProgram"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const CheckProgramRoute = Route;
